<template>
  <div class="relative area-size">
    <slot :keys="keys"></slot>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { layout_bounds } from "@/keyboard/layout";
import { useLayoutStore } from "@/stores";
import { useScreenSize } from "@/composables";

const props = defineProps<{
  height?: number;
  width?: number;
}>();

const layout = useLayoutStore();
const screenSize = useScreenSize();

// TODO: cannot decrease width too much, think of a better solution for mobile screens
const defaultHeight = ref(3000); // don't care as keyboard width is bigger than height
const defaultWidth = computed(() =>
  screenSize.value == "desktop" ? 1200 : 1000
);

const keys = computed(() => {
  const transform = layout.layout.fit_size({
    x: props.width ?? defaultWidth.value,
    y: props.height ?? defaultHeight.value,
  });
  return layout.layout.iter_transform(transform);
});

const area_size = computed(() => {
  const [area_min, area_max] = layout_bounds(keys.value);
  const area_width = area_max.x - area_min.x;
  const area_height = area_max.y - area_min.y;
  return {
    x: area_width,
    y: area_height,
  };
});

const area_width = computed(() => area_size.value.x);
const area_height = computed(() => area_size.value.y);
</script>

<style scoped>
.area-size {
  width: v-bind(area_width + "px");
  height: v-bind(area_height + "px");
}
</style>
